import { useApplicationStore } from '@data';
import { useShallow } from 'zustand/shallow';

export function useIsLoggedIn() {
  const isLoggedIn = useApplicationStore(
    useShallow((state) =>
      Boolean(state.auth.accessToken && state.patient.patientProfile),
    ),
  );
  return { isLoggedIn };
}
